/** The unified checkout, entered with the whole cart. */
export const CART_CHECKOUT_PATH = '/checkout?cart_mode=true';
